import axios, { AxiosError } from "axios";

export const api = axios.create({
  baseURL: "/api",          // Vite dev-server proxies /api → http://localhost:5022
  withCredentials: true,
  timeout: 15_000,
});

api.interceptors.response.use(
  (r) => r,
  (err: AxiosError<{ ok: false; error?: { message: string; code?: string } }>) => {
    if (err.response?.status === 401) {
      // Clear cached user; routing will redirect to /login.
      try {
        const { queryClient } = require("./query") as typeof import("./query");
        queryClient.removeQueries({ queryKey: ["me"] });
      } catch {/* circular guard */}
    }
    return Promise.reject(err);
  }
);

export interface ApiOk<T> { ok: true; data: T }
export interface ApiErr { ok: false; error: { message: string; code?: string } }
export type ApiResult<T> = ApiOk<T> | ApiErr;

export function unwrap<T>(payload: ApiResult<T>): T {
  if (!payload.ok) throw new Error(payload.error.message);
  return payload.data;
}

export function describeError(err: unknown): string {
  if (axios.isAxiosError(err)) {
    const data = err.response?.data as ApiErr | undefined;
    return data?.error?.message ?? err.message ?? "Network error";
  }
  return (err as Error)?.message ?? "Unexpected error";
}
